import {Observable} from "rxjs";

export abstract class StoredPaymentMethodRepository {
    abstract delete(storedPaymentMethodId: string): Observable<void>;
}